export const eventBus = {
    on(event, callback) {
        if (!document)
            return;
        document.addEventListener(event, (e) => callback(e.detail));
    },
    dispatch(event, data) {
        if (!document)
            return;
        document.dispatchEvent(new CustomEvent(event, { detail: data }));
    },
    remove(event, callback) {
        if (!document)
            return;
        document.removeEventListener(event, callback);
    }
}